import React from "react";
import WeducNotices from "@accrosoft-ltd/accropress-websites-components/dist/esm/weducNotices";
import Slider from "react-slick";
import "./NoticesSlickSlider.css";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

function checkIsURLAnImage(url) {
  return url.match(/\.(jpeg|jpg|gif|png)$/) != null;
}

export function NoticeTemplate(props) {
  return /*#__PURE__*/_jsxs("div", {
    className: "weduc-notices-slider-card",
    children: [props.data.attachment && props.data.attachment[0] && props.data.attachment[0].external_url && checkIsURLAnImage(props.data.attachment[0].external_url) ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("div", {
        className: "weduc-notices-slider-card-image",
        children: /*#__PURE__*/_jsx("img", {
          src: props.data.attachment[0].external_url,
          alt: props.data.title.replace(/&nbsp;/g, "").replace(/&pound;/g, "£")
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "weduc-notices-slider-card-title",
        children: /*#__PURE__*/_jsx("h3", {
          children: props.data.title.replace(/&nbsp;/g, "").replace(/&pound;/g, "£")
        })
      })]
    }) : props.data.attachment && props.data.attachment[0] && props.data.attachment[0].external_url && /*#__PURE__*/_jsx("div", {
      className: "weduc-notices-slider-card-title",
      children: /*#__PURE__*/_jsx("a", {
        href: props.data.attachment[0].external_url,
        title: props.data.attachment[0].title,
        target: "_blank",
        children: /*#__PURE__*/_jsx("strong", {
          children: props.data.title.replace(/&nbsp;/g, "").replace(/&pound;/g, "£")
        })
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "weduc-notices-slider-card-content",
      children: /*#__PURE__*/_jsx("p", {
        children: props.data.snippet.replace(/&nbsp;/g, "").replace(/&pound;/g, "£")
      })
    })]
  });
}

var NoticesSlickSlider = function NoticesSlickSlider(props) {
  var settings = {
    dots: props.showDots || true,
    infinite: props.infinite || true,
    speed: props.speed || 500,
    slidesToShow: props.slidesToShow || 1,
    slidesToScroll: props.slidesToShow || 1
  };
  return /*#__PURE__*/_jsx("div", {
    className: "noticesBanner weducWidgetDisplay_" + props.noticesMainLoaded,
    children: /*#__PURE__*/_jsx(Slider, Object.assign({
      className: "weduc-notices-slider"
    }, settings, {
      children: /*#__PURE__*/_jsx(WeducNotices, {
        className: "weduc-notices",
        delay: props.delay || 5,
        limit: props.limit || 5,
        name: props.config.weducWebsitesID,
        container: props.config.weducEntityID,
        html: NoticeTemplate,
        loadedEvent: props.setNoticesMainLoaded
      })
    }))
  });
};

export default NoticesSlickSlider;